import { type LocationCustomData, type LocationListInput, type LocationListSuccess } from '@terros/common'
import { keepPreviousData } from '@tanstack/react-query'
import { customLocationsKey } from '../keys'
import { type GetInfiniteHookResponse, useTantalimInfiniteQuery } from '../infiniteQuery'

const PAGE_SIZE = 100

export type CustomLocationsFilter = Pick<LocationListInput, 'query' | 'cities' | 'states' | 'zipCodes'>

/** Searches and pages the company's custom locations on the server; `total` counts every match, not just loaded pages. */
export function useCustomLocations(filter: CustomLocationsFilter = {}): GetInfiniteHookResponse<LocationCustomData> {
  return useTantalimInfiniteQuery<LocationListInput, LocationListSuccess, LocationCustomData>({
    url: '/location/list',
    // nested under customLocationsKey so invalidating it refreshes every search
    queryKey: [...customLocationsKey, filter],
    input: { ...filter, size: PAGE_SIZE },
    selectRecords: (page) => page.locations,
    // keep showing the previous results while a new search loads
    placeholderData: keepPreviousData,
  })
}
